import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { verificationCode } from "../../../utils/usermanagement";

// import images
import { layoutModeTypes } from "../../../Components/constants/layout";
import logoDark from '../../../assets/images/exiaLogo_dark.png';
import logoLight from '../../../assets/images/exiaLogo_light.png';
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

const VerificationCode = props => {
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      code: '',
    },
    validationSchema: Yup.object({
        code: Yup.string().required("Please Enter Your code"),
    }),
    onSubmit:async (values) => {
      
      try { 
        console.log('values', values);

        const response = await verificationCode(values);
        if (response.success) { 
          const session_code = response.session_code;
          const token = response.token;
          sessionStorage.setItem("authToken", token);
          sessionStorage.setItem("sessionCode", session_code);
          props.router.navigate("/changePassword"); // Redirect to a protected page 
        } else if (response.code === 404) {
            alert(response.message);
        } else {
            // setError(response.message);
            console.error("Error:",response.message);
        }
    } catch (err) {
        console.error('submit failed. Please try again.Error', err);
        // setError('Login failed. Please try again.');
    }
    }
  });

  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg
  } = useSelector(selectLayoutProperties);

  // Get the current layout mode from Redux store
  const selectLayoutModeState = (state) => state.Layout;
  const layoutModeData = createSelector(
    selectLayoutModeState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType: currentLayoutMode } = useSelector(layoutModeData);

  // Use the actual layout mode from Redux instead of hardcoded logic
  const mode = currentLayoutMode || layoutModeTypes.LIGHTMODE;
  
  document.title="Reset Password | SeedNations";

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                    <img src={mode === layoutModeTypes.LIGHTMODE ? logoLight : logoDark} alt="" height="200" />
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium">Put Seed Nations slogan here</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <div className="mt-4">

                <div className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">input your vevrification code here</h5>
                    <p className="text-muted">check the vevrification code in your email!</p>
 

                  </div>

                  {/* <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your email and instructions will be sent to you!
                  </Alert> */}
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">vevrification code</Label>
                        <Input
                          name="code"
                          className="form-control"
                          placeholder="Enter code"
                          type="code"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.code || ""}
                          invalid={
                            validation.touched.code && validation.errors.code ? true : false
                          }
                        />
                        {validation.touched.code && validation.errors.code ? (
                          <FormFeedback type="invalid"><div>{validation.errors.code}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn   w-100"   style={{backgroundColor:'#24F4C0',color:'#000'}} type="submit">Submit</button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
 
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

VerificationCode.propTypes = {
  history: PropTypes.object,
};

export default withRouter(VerificationCode);
